"use client"

import { GetPageQuery } from "apollo"
import {
  BlockRenderer,
  Container,
  ContentText,
  CustomBreadcrumbs,
  ImageTextBlock,
  TopBanner,
} from "ui"
import { NumbersGridBackgroundProps } from "ui/NumbersComponent/NumbersGrid"
import { getBreadCrumbs } from "utils"
import { findProperty } from "utils/findProperty"
import ButtonsComponent from "./ButtonsComponent"
import EnvironmentalHeader from "./EnvironmentalHeader"
import InvestmentBlock from "./InvestmentBlock"
import NumbersContainer from "./NumbersContainer"
import SingleFileBlock from "./SingleFileBlock"
import Slider from "./Slider"
import TitleContent from "./TitleContent"

type Props = {
  data: GetPageQuery
  locale: string
  imgTxtPadding?: boolean
  galleryBottom?: boolean
  numbersComponentColors?: NumbersGridBackgroundProps
}

function EsgInnerPage({
  data,
  locale,
  imgTxtPadding,
  galleryBottom,
  numbersComponentColors,
}: Props) {
  const { selfObject, parents } = getBreadCrumbs(data, locale)
  const components = {
    environmentalHeader: EnvironmentalHeader,
    topBanner: TopBanner,
    numbersEnvironmental: NumbersContainer,
    basicTitleAndTextBlock: TitleContent,
    dynamicSlider: Slider,
    imageTextBlock: ImageTextBlock,
    imageTextBlock2: ImageTextBlock,
    reportButtons: ButtonsComponent,
    investmentBlock: InvestmentBlock,
    singleFileBlock: SingleFileBlock,
    contentText: ContentText,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []
  const hasBanner = blocks?.some(
    (block: any) => block.blockType === "topBanner" || block.blockType === "HeaderWithHeroAndText",
  )
  return (
    <>
      <Container>
        <CustomBreadcrumbs current={selfObject} parents={parents} />
      </Container>
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "numbersEnvironmental") {
          additionalProps = { backgroundColors: numbersComponentColors, showIcons: false }
        } else if (block.blockType === "imageTextBlock2" || block.blockType === "imageTextBlock") {
          additionalProps = { noMargin: true, imgTxtPadding }
        } else if (block.blockType === "dynamicSlider") {
          additionalProps = { galleryBottom }
        } else if (block.blockType === "topBanner") {
          additionalProps = { videoHeight: "500px", imageHeight: "500px" }
        } else if (block.blockType === "contentText") {
          additionalProps = {
            hasBanner: hasBanner,
          }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            locale={locale}
            props={additionalProps}
          />
        )
      })}
    </>
  )
}

export default EsgInnerPage
